import { render, staticRenderFns } from "./panel_genjin.vue?vue&type=template&id=a89af6fe&scoped=true&"
import script from "./panel_genjin.vue?vue&type=script&lang=js&"
export * from "./panel_genjin.vue?vue&type=script&lang=js&"
import style0 from "./panel_genjin.vue?vue&type=style&index=0&id=a89af6fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89af6fe",
  null
  
)

export default component.exports